import { getToken } from "@/lib/auth";
import { getApiDomain } from "@/lib/ajax";

const domain = getApiDomain();
const url = `wss:${domain}/agent/socket/connect`;

let websocketRuning = false;
let websocket = null;
let websocketCallback = null;

function startSocket() {
    if (websocketRuning) {
        return;
    }
    let wsuri = `${url}?i=${Math.random()}&token=${getToken()}`;
    websocket = new WebSocket(wsuri);

    websocket.onmessage = e => {
        let { content: sourceContent, id } = JSON.parse(e.data);
        websocket.send(JSON.stringify({ id }));
        try {
            if (sourceContent) {
                let { event_type, content } = JSON.parse(sourceContent);
                websocketCallback({ eventType: event_type, content });
            }
        } catch (e) {
            websocket.send("解析后端返回的数据报错:" + id);
        }
    };
    websocket.onclose = () => {
        websocketRuning = false;
        setTimeout(startSocket, 5000);
        websocketCallback({ eventType: "SOCKET_CLOSE" });
    };
    websocket.onopen = () => {
        websocketRuning = true;
        websocketCallback({ eventType: "SOCKET_OPEN" });
    };
}

function startPolling(callback) {
    websocketCallback = callback;
    startSocket();
}

function stopPolling() {
    if (websocket) {
        websocket.close();
    }
}

export { startPolling, stopPolling };
